import React, { Component } from 'react'
import Table from 'react-bootstrap/Table';

export default class ProductSubscriptionsSkeleton extends Component {
    render() {
        return (
            <>
            <div className="row  mt-10">
                <div className="col-sm-12">
                    <div className="subscription-plan-table table-responsive bg-white rounded accordion mb-8">
                        <Table className="plan_sub_table">
                            <thead>
                                <tr>
                                    <th style={{minWidth:"150px"}}>
                                        <p className="sk_line sk_line_40 sk_line_height_18 mb-0 mt-0"></p>
                                    </th>
                                    <th style={{minWidth:"60px"}}>
                                        <p className="sk_line sk_line_50 sk_line_height_18 mb-0 mt-0"></p>
                                    </th>
                                    <th style={{minWidth:"80px"}}>
                                        <p className="sk_line sk_line_40 sk_line_height_18 mb-0 mt-0"></p>
                                    </th>
                                    <th style={{minWidth:"50px"}}>
                                        <p className="sk_line sk_line_70 sk_line_height_18 mb-0 mt-0"></p>
                                    </th>
                                    <th style={{minWidth:"110px"}}>
                                        <p className="sk_line sk_line_50 sk_line_height_18 mb-0 mt-0" style={{float: "right"}}></p>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center flex-nowrap">
                                            <div className="flex-shrink-0 me-4">
                                                <div className="symbol symbol-40">
                                                    <div className="sk_img ProdSubs_icon rounded-1 m-auto"></div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
                                                <div className="me-3 w-100">
                                                    <h4 className="sk_line sk_line_30 sk_line_height_14 mb-5 mt-0"></h4>
                                                    <p className="sk_line sk_line_40 sk_line_height_10 mb-0"></p>
                                                </div>       
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_16 mb-0"></p> 
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column text-left">
                                            <p className="sk_line sk_line_70 sk_line_height_16 mb-0"></p>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_24 rounded-1 mb-0"></p>
                                    </td>
                                    <td className="text-end" align={"right"}>
                                        <div className="upgrade-cancel-link d-flex justify-content-end">
                                            <p className="sk_line sk_line_50 sk_line_height_28 rounded-1 mb-0"></p>
                                            <p className="sk_line sk_line_20 sk_line_height_28 rounded-1 ms-4 mb-0"></p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center flex-nowrap">
                                            <div className="flex-shrink-0 me-4">
                                                <div className="symbol symbol-40">
                                                    <div className="sk_img ProdSubs_icon rounded-1 m-auto"></div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
                                                <div className="me-3 w-100">
                                                    <h4 className="sk_line sk_line_30 sk_line_height_14 mb-5 mt-0"></h4>
                                                    <p className="sk_line sk_line_40 sk_line_height_10 mb-0"></p>
                                                </div>       
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_16 mb-0"></p> 
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column text-left">
                                            <p className="sk_line sk_line_70 sk_line_height_16 mb-0"></p>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_24 rounded-1 mb-0"></p>
                                    </td>
                                    <td className="text-end" align={"right"}>
                                        <div className="upgrade-cancel-link d-flex justify-content-end">
                                            <p className="sk_line sk_line_50 sk_line_height_28 rounded-1 mb-0"></p>
                                            <p className="sk_line sk_line_20 sk_line_height_28 rounded-1 ms-4 mb-0"></p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center flex-nowrap">
                                            <div className="flex-shrink-0 me-4">
                                                <div className="symbol symbol-40">
                                                    <div className="sk_img ProdSubs_icon rounded-1 m-auto"></div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
                                                <div className="me-3 w-100">
                                                    <h4 className="sk_line sk_line_30 sk_line_height_14 mb-5 mt-0"></h4>
                                                    <p className="sk_line sk_line_40 sk_line_height_10 mb-0"></p>
                                                </div>       
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_16 mb-0"></p> 
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column text-left">
                                            <p className="sk_line sk_line_70 sk_line_height_16 mb-0"></p>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_24 rounded-1 mb-0"></p>
                                    </td>
                                    <td className="text-end" align={"right"}>
                                        <div className="upgrade-cancel-link d-flex justify-content-end">
                                            <p className="sk_line sk_line_50 sk_line_height_28 rounded-1 mb-0"></p>
                                            <p className="sk_line sk_line_20 sk_line_height_28 rounded-1 ms-4 mb-0"></p>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="d-flex align-items-center flex-nowrap">
                                            <div className="flex-shrink-0 me-4">
                                                <div className="symbol symbol-40">
                                                    <div className="sk_img ProdSubs_icon rounded-1 m-auto"></div>
                                                </div>
                                            </div>
                                            <div className="d-flex align-items-center justify-content-between flex-wrap w-100">
                                                <div className="me-3 w-100">
                                                    <h4 className="sk_line sk_line_30 sk_line_height_14 mb-5 mt-0"></h4>
                                                    <p className="sk_line sk_line_40 sk_line_height_10 mb-0"></p>
                                                </div>       
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_16 mb-0"></p> 
                                    </td>
                                    <td>
                                        <div className="d-flex flex-column text-left">
                                            <p className="sk_line sk_line_70 sk_line_height_16 mb-0"></p>
                                        </div>
                                    </td>
                                    <td>
                                        <p className="sk_line sk_line_50 sk_line_height_24 rounded-1 mb-0"></p>
                                    </td>
                                    <td className="text-end" align={"right"}>
                                        <div className="upgrade-cancel-link d-flex justify-content-end">
                                            <p className="sk_line sk_line_50 sk_line_height_28 rounded-1 mb-0"></p>
                                            <p className="sk_line sk_line_20 sk_line_height_28 rounded-1 ms-4 mb-0"></p>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </Table>
                    </div>
                </div>
            </div>

            <div className="row">
                <div className="col-sm-12 mt-20">
                    <div id="paymentMethodNew" className="payment-method-new">
                        <div className="payment-box bg-white rounded">
                            <div className="sk_loader_ stripe_card">
                                <div className="card-list-main">
                                    <ul className="list-unstyled mb-5 pb-1">
                                        <li className="add-card-item">
                                            <div className="add-card d-flex align-items-center default border shadow-none">
                                                <span className="card-img">
                                                    <p className="sk_line sk_line_70 sk_line_height_32 rounded-1 m-0"></p>
                                                </span>
                                                <p className="card-number m-0 text-dark">
                                                    <p className="sk_line sk_line_30 sk_line_height_12 m-0 mb-2"></p> 
                                                    <span><p className="sk_line sk_line_70 sk_line_height_10 m-0"></p></span>
                                                </p>
                                                <p className="lable m-0">
                                                    <span className="label-inline get-default-data change-card-text">
                                                        <p className="sk_line sk_line_50 sk_line_height_20 rounded-1 m-0"></p>
                                                    </span>
                                                </p>
                                                <span className="saprator border-0"></span>
                                                <p className="sk_line sk_line_10 sk_line_height_20 rounded-1 m-0 me-3"></p>
                                                <p className="sk_line sk_line_10 sk_line_height_20 rounded-1 m-0"></p>
                                            </div>
                                        </li>
                                    </ul>
                                    <div className="StripeElement">
                                        <div className="row align-items-center">
                                            <div className="col-md-6">
                                                <p className="sk_line sk_line_50 sk_line_height_14 mb-3"></p>
                                                <div className="d-flex align-items-center justify-content-between border rounded-1 w-100 p-3">
                                                    <p className="sk_line sk_line_50 sk_line_height_20 m-0"></p>
                                                    <p className="sk_line sk_line_20 sk_line_height_24 rounded-1 m-0"></p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <p className="sk_line sk_line_60 sk_line_height_14 mb-3"></p>
                                                <div className="d-flex align-items-center justify-content-between border rounded-1 w-100 p-3">
                                                    <p className="sk_line sk_line_50 sk_line_height_20 m-0"></p>
                                                </div>
                                            </div>
                                            <div className="col-md-3">
                                                <p className="sk_line sk_line_50 sk_line_height_14 mb-3"></p>
                                                <div className="d-flex align-items-center justify-content-between border rounded-1 w-100 p-3">
                                                    <p className="sk_line sk_line_50 sk_line_height_20 m-0"></p>
                                                    <p className="sk_line sk_line_20 sk_line_height_24 rounded-1 m-0"></p>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-3">
                                                <p className="sk_line sk_line_20 sk_line_height_14 mb-3"></p>
                                                <div className="d-flex align-items-center justify-content-between border rounded-1 w-100 p-3">
                                                    <p className="sk_line sk_line_50 sk_line_height_20 m-0"></p>
                                                    <p className="sk_line sk_line_20 sk_line_height_24 rounded-1 m-0"></p>
                                                </div>
                                            </div>
                                            <div className="col-sm-12 mt-3">
                                                <p className="sk_line sk_line_height_10 mb-2"></p>
                                                <p className="sk_line sk_line_20 sk_line_height_10 m-0"></p>
                                                <p className="sk_line sk_line_20 sk_line_height_36 rounded-1 mt-4"></p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            </>
        )
    }
}
